/**
 * Dedupe a flattened feed id list, first occurrence wins.
 *
 * The ranked feed backing store (Redis) can be rebuilt/rescored and fan out mid-scroll, so
 * two infinite-query pages fetched moments apart can legitimately share an id even after
 * server-side pagination fixed the deterministic duplication case. This is the client-side
 * backstop: it guarantees a question is never RENDERED twice regardless of what the server
 * pages contain (backend #680 tracks the server-side snapshot-pagination fix).
 */
export function dedupeIds(ids: string[]): string[] {
  return [...new Set(ids)];
}
